export class TrexoFailure {
    static NON_NEIGHBORING_SPACES = () => $localize `Those two spaces are not neighbors!`;
    static NO_WAY_TO_DROP_IT_HERE = () => $localize `There is no way to put a piece there!`;
    static CANNOT_DROP_ON_ONLY_ONE_PIECE = () => $localize `You cannot drop on only one piece!`;
    static CANNOT_DROP_PIECE_ON_UNEVEN_GROUNDS = () => $localize `You cannot drop a piece on uneven grounds!`;
}
